"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzItem = exports.SzList = void 0;

var react_1 = __importStar(require("react"));

var ListGroup_1 = __importDefault(require("react-bootstrap/ListGroup"));

var react_transition_group_1 = require("react-transition-group");

var classnames_1 = __importDefault(require("classnames"));

require("./SzList.scss");

var ListContext = react_1.default.createContext({});
var duration = 300;
var defaultStyle = {
  transition: "left " + duration + "ms ease-in, right " + duration + "ms ease-in",
  left: '0',
  right: '0'
};
var transitionStyles = {
  entering: {
    left: '50%',
    right: '50%'
  },
  entered: {
    left: '0%',
    right: '0%'
  },
  exiting: {
    left: '70%',
    right: '70%'
  },
  exited: {
    left: '100%',
    right: '100%'
  }
};

exports.SzList = function (_a) {
  var children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'flush' : _b,
      className = _a.className,
      props = __rest(_a, ["children", "variant", "className"]);

  var classes = classnames_1.default('sz-list', className);
  return react_1.default.createElement(ListContext.Provider, {
    value: __assign(__assign({}, props), {
      variant: variant
    })
  }, react_1.default.createElement(ListGroup_1.default, __assign({
    variant: variant,
    as: "ul",
    className: classes
  }, props), children));
};

exports.SzItem = function (_a) {
  var children = _a.children,
      className = _a.className,
      active = _a.active,
      props = __rest(_a, ["children", "className", "active"]);

  var horizontal = react_1.useContext(ListContext).horizontal;
  var classes = classnames_1.default('sz-list_item d-flex align-items-center', className, {
    'sz-list_item-horizontal': horizontal
  });
  return react_1.default.createElement(ListGroup_1.default.Item, __assign({
    as: "li",
    active: active,
    className: classes
  }, props), react_1.default.createElement("span", {
    className: "sz-list_item-text w-100"
  }, children), horizontal && react_1.default.createElement(react_transition_group_1.Transition, {
    in: active,
    timeout: duration
  }, function (state) {
    return react_1.default.createElement("span", {
      style: __assign(__assign({}, defaultStyle), transitionStyles[state]),
      className: "sz-list_item-border " + state
    });
  }));
};

exports.SzList.Item = exports.SzItem;
exports.default = exports.SzList;